import React from 'react';
import useResponsive from '../hooks/useResponsive';

const ResponsivePagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  showFirstLast = true,
  showPrevNext = true,
  maxVisiblePages = 5 
}) => {
  const { isMobile, isTablet } = useResponsive();

  // Calculate visible page numbers
  const getVisiblePages = () => {
    const pages = [];
    const maxVisible = isMobile ? 3 : isTablet ? 4 : maxVisiblePages;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const half = Math.floor(maxVisible / 2);
      let start = Math.max(1, currentPage - half);
      let end = Math.min(totalPages, start + maxVisible - 1);
      
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  const visiblePages = getVisiblePages();

  if (totalPages <= 1) return null;

  return (
    <div className="responsive-pagination">
      <div className="pagination-wrapper">
        {showFirstLast && currentPage > 1 && (
          <button
            className="pagination-btn first-btn"
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            aria-label="First page"
          >
            {isMobile ? '«' : 'First'}
          </button>
        )}
        
        {showPrevNext && (
          <button
            className="pagination-btn prev-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            {isMobile ? '‹' : 'Previous'}
          </button>
        )}

        <div className="page-numbers">
          {visiblePages.map((page) => (
            <button
              key={page}
              className={`pagination-btn page-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => onPageChange(page)}
              aria-label={`Page ${page}`}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {page}
            </button>
          ))}
        </div>

        {showPrevNext && (
          <button
            className="pagination-btn next-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            {isMobile ? '›' : 'Next'}
          </button>
        )}
        
        {showFirstLast && currentPage < totalPages && (
          <button
            className="pagination-btn last-btn"
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            aria-label="Last page"
          >
            {isMobile ? '»' : 'Last'}
          </button>
        )}
      </div>
      
      {!isMobile && (
        <div className="pagination-info">
          <span>
            Page {currentPage} of {totalPages}
          </span>
        </div>
      )}
    </div>
  );
};

export default ResponsivePagination;
